import * as actions from "../actions/couponActions";

const initialState = {
  bets: [],
  errors: [],
  couponState: {
    open: false,
    waiting: false,
    placed: false
  }
};

const betKey = action => [action.marketId, action.betId].join("@");

export default function coupon(state = initialState, action) {
  switch (action.type) {
    case actions.SET_COUPON_STATE: {
      return {
        ...state,
        couponState: {
          ...state.couponState,
          ...action.couponState
        }
      };
    }
    case actions.ADD_BET: {
      return {
        ...state,
        errors: [],
        bets: [...state.bets.filter(id => id !== betKey(action)), betKey(action)],
        couponState: {
          ...state.couponState,
          open: true
        }
      };
    }
    case actions.REMOVE_BET: {
      return {
        ...state,
        errors: [],
        bets: state.bets.filter(id => id !== betKey(action))
      };
    }
    case actions.REMOVE_ALL: {
      return {
        ...state,
        bets: [],
        couponState: {
          ...state.couponState,
          open: false
        }
      };
    }
    case actions.OPEN: {
      return {
        ...state,
        couponState: {
          ...state.couponState,
          open: true
        }
      };
    }
    case actions.CLOSE: {
      return {
        ...state,
        couponState: {
          ...state.couponState,
          open: false
        }
      };
    }
    case actions.SET_ERROS: {
      return {
        ...state,
        errors: action.errors
      };
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./app/reducers/coupon.js